<form [formGroup]="responsibleGamingForm" id="responsibleGamingForm"
  class="
    responsible-gaming-form-page
  "
  data-cy="resp-gaming-screen"
>

  <!-- Timeout exclusion -->
  <div class="timeout-exclusion-section tw-text-center tw-text-[14px] tw-text-[#5D5D5D]">
    <p class="tw-mb-[5px]" data-cy="resp-txt-1">
      We’re committed to protecting our AmWager players. To
      help you manage your play in a healthy, responsible way,
      we offer proactive tools and support
    </p>

    <p class="tw-mb-[14px]" data-cy="resp-timeout-txt">
      <span class="tw-font-bold tw-text-[17px] tw-text-[#0F2950]">
        Timeout & Exclusion
      </span> <br>
      Take a break from AmWager with a Timeout
      Tell us how much time you need away and we’ll make
      sure you can only log into AmWager products after the
      time out has ended.
    </p>
  </div>

  <!-- Timout self exclude -->
  <div class="timeout-self-exclude-section tw-flex tw-text-[16px] tw-text-[#000000] tw-mb-[15px]">
    <div
      (click)="responsibleTypeIs('timeout')"
      class="
        tw-flex tw-bg-[#E4ECF7] tw-rounded-[5px] tw-border-[1px] tw-border-[#2F7EE8] tw-mr-[7.5px]
      "
      data-cy="resp-timeout-btn"
    >
      <img
        class="l-mode tw-mr-[15px]"
        src="/assets/images/profile/responsible_gaming/timeout_icon_light.svg"
        alt="timeout icon"
      >
      <img
        class="d-mode tw-mr-[15px]"
        src="/assets/images/profile/responsible_gaming/timeout_icon_dark.svg"
        alt="timeout icon"
      >
      <span>
        Timeout <br> 3-365 Days
      </span>
    </div>
    <div
      (click)="responsibleTypeIs('self-exclude')"
      class="
        tw-flex tw-bg-[#E4ECF7] tw-rounded-[5px] tw-border-[1px] tw-border-[#2F7EE8] tw-ml-[7.5px]
      "
      data-cy="resp-self-btn"
    >
      <img
        class="l-mode tw-mr-[12px]"
        src="/assets/images/profile/responsible_gaming/self_exclude_icon_light.svg"
        alt="self exclude icon"
      >
      <img
        class="d-mode tw-mr-[12px]"
        src="/assets/images/profile/responsible_gaming/self_exclude_icon_dark.svg"
        alt="self exclude icon"
      >
      <span>
        Self - Exclude <br> 1-5 Years
      </span>
    </div>
  </div>

  <!-- What time out  -->
  <div class="what-timeout-means-section">
    <p class="tw-text-center tw-font-bold tw-text-[17px] tw-text-[#0F2950]" data-cy="resp-options-meaning">
      {{
        responsibleType === 'self-exclude' ?
        'What a Self-exclusion means:'
          :
        'What a Timeout means:'
      }}
    </p>
    <ul>
      <li class="tw-relative tw-text-[14px] tw-text-[#5D5D5D]" data-cy="resp-bullet-1">
        You can’t log into your account.
      </li>
      <li class="tw-relative tw-text-[14px] tw-text-[#5D5D5D]" data-cy="resp-bullet-2">
        {{
          responsibleType === 'self-exclude' ?
          "You'll need to contact Support to reactivate after exclusion period"
            :
          'Your account will reactivate automatically at the end of your Timeout.'
        }}
      </li>
      <li class="tw-relative tw-text-[14px] tw-text-[#5D5D5D]" data-cy="resp-bullet-3">
        You won’t receive any marketing communications.
      </li>
    </ul>
  </div>

  <!-- Message section -->
  <div class="">
    <span
      class="tw-text-xs tw-text-[#D83A19]"
      *ngIf="formVal['days'] && formVal['days'].errors
        && (formVal['days'].touched || formVal['days'].dirty)"
        data-cy="resp-timeout-error"
    >
      {{
        formVal['days'].errors['min']
          ? 'Minimum timeout day is 3 days.'
          : formVal['days'].errors['max']
            ? 'Maximum timeout day is 365 days.'
            : 'Please enter Number of Days.'
      }}
    </span>

    <span
      class="tw-text-xs tw-text-[#D83A19]"
      *ngIf="formVal['selfExclude'] && formVal['selfExclude'].errors
        && (formVal['selfExclude'].touched || formVal['selfExclude'].dirty)"
    >
      Please select Self-Exclude Length.
    </span>
  </div>

  <!-- Enter number of days or select year -->
  <div class="enter-number-of-days-section tw-mb-[18px]">

    <div class="tw-flex">
      <input
        *ngIf="responsibleType === 'timeout'"
        formControlName="days"
        class="
          days
          tw-w-[50%]
          tw-h-[38px]
          tw-bg-[#EAEAEA]
          tw-rounded-[4px]
          tw-border-[1px]
          tw-border-[#959595]
          tw-mr-[6px]
          tw-px-[10px]
        "
        type="number"
        placeholder="Enter number of Days"
        (keyup.enter)="responsibleGamingForm.valid ? doresponsibleGamingForm() : null"
        data-cy="resp-timeout-input"
      >

      <ion-select
        *ngIf="responsibleType === 'self-exclude'"
        formControlName="selfExclude"
        fill="outline"
        label-placement="stacked"
        interface="popover"
        toggleIcon=""
        expandedIcon=""
        class="
          years
          tw-bg-[#EAEAEA]
          tw-w-[50%]
          tw-rounded-[4px]
          tw-mr-[5px]
        "
        data-cy="resp-self-dropdown"
      >
        <ion-select-option value="1">1 Year</ion-select-option>
        <ion-select-option value="3">3 Years</ion-select-option>
        <ion-select-option value="5">5 Years</ion-select-option>
        <ion-select-option value="999">Lifetime</ion-select-option>
      </ion-select>

      <button
        (click)="doresponsibleGamingForm()"
        class="
          submit-request
          tw-relative
          tw-w-[50%]
          tw-h-[38px]
          tw-bg-[#3080EC]
          tw-rounded-[4px]
          tw-capitalize
          tw-text-[16px]
          tw-text-[#FFFFFF]
          tw-pr-[20px]
        "
        [class.tw-ml-[6px]]="responsibleType === 'timeout'"
        [class.tw-ml-[8px]]="responsibleType === 'self-exclude'"
        [disabled]="isProccesing"
        data-cy="resp-submit-btn"
      >
        submit request
        <ion-icon
          name="arrow-forward-outline"
          class="tw-absolute tw-text-[25px] tw-text-[#356AB1]"
        >
        </ion-icon>
      </button>
    </div>

    <!-- Message ssction from API response -->
    <div class="
      tw-pt-[5px]
      tw-text-center
    ">
      <span *ngIf="responsibleGamingForm.errors" class="error-msg tw-text-xs tw-text-[#D83A19]">
        {{ responsibleGamingForm.errors['apiResponse'] }}
      </span>
    </div>

  </div>

  <!-- QR code -->
  <div class="qr-section tw-text-center tw-text-[14px] tw-text-[#5D5D5D]">
    <p class="tw-mb-[15px]" data-cy="resp-txt-2">
      If you suspect that you or someone you know may have a
      problem related to gambling, or for additional information <br>
      <span class="tw-text-[#6FAAFA]" data-cy="resp-txt-3">Please call: 1-800-GAMBLER</span>
    </p>
    <p class="tw-text-[14px] tw-text-[#5D5D5D] tw-mb-[15px]" data-cy="resp-txt-4">
      New York Residents: Request of voluntary self exclusion
      for all gaming facilities and entities license, permitted or
      registered by the New York State Gaming Commission
      can be done here: <br>
      <a
        href="https://www.gaming.ny.gov/pdf/UpdatedSEForm-091020.pdf"
        target="_blank"
        class="tw-text-[13px] tw-text-[#6FAAFA]"
        data-cy="resp-link-1"
      >
        https://www.gaming.ny.gov/pdf/UpdatedSEForm-091020.pdf
      </a>
    </p>

    <img
      class="qr-code"
      src="/assets/images/profile/responsible_gaming/qr_code.png"
      width="118"
      alt="qr code icon"
      data-cy="resp-qr-code"
    >

    <p class="tw-text-[14px] tw-text-[#5D5D5D] tw-mt-[15px] tw-mb-[40px]" data-cy="resp-txt-5">
      <span class="scan-here tw-font-bold tw-text-[#0F2950]" data-cy="resp-scan-here">Scan Here</span>
      to talk to someone about your gambling. For
      help with a gambling problem call 1-877-8HOPE-NY or
      Text HOPENY (467369). Standard rates may apply. <br>
      <a href="https://nyproblemgamblinghelp.org" target="_blank" class="tw-text-[#6FAAFA]" data-cy="resp-link-2">
        https://nyproblemgamblinghelp.org
      </a>
    </p>
  </div>

</form>
